import React, {useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toggleModal } from '../store/actions/toggleModalActions';
import { createFieldGroup } from '../store/actions/fieldGroupsActions';
import './FieldModal.scss';

import ButtonSpinner from "./_common/ButtonSpinner";

const selector = state => {
    const { language, disableButtons, fieldGroups } = state;
    return {
        t: language.translator,
        disableButtons: disableButtons,
        selected: fieldGroups.selected
    }
};

const FieldGroupModal = props => {
    const { edit, fieldGroup } = props;
    const { t, disableButtons } = useSelector(selector);
    const dispatch = useDispatch();

    const [fieldGroupName, setFieldGroupName] = useState(fieldGroup ? fieldGroup.name : '');

    const closeModal = () => {
        dispatch(toggleModal(false, ''));
    };

    const handleCreateFieldGroupClick = () => {
        dispatch(createFieldGroup(fieldGroupName));
        closeModal();
    };

    return (
        <div
            className='fieldModalBlur'
            onClick={e => {
                if(e.target.className === 'fieldModalBlur') {
                    closeModal()
                }
            }}
        >
            <div className='fieldModal'>
                <div className='fieldModalHeader'>
                    <div className='fieldModalTitleContainer'>
                        <div className='fieldModalTitle'>
                            {!edit ? t.gettext('Add New Field Group') : t.gettext('Edit Field Group') }
                        </div>
                    </div>
                    <div className='fieldModalCloseButtonHolder'>
                        <span
                            className='material-icons fieldModalCloseButton'
                            onClick={closeModal}
                        >
                            cancel
                        </span>
                    </div>
                </div>
                <div className='fieldModalContent'>
                    <form className='fieldForm' autoComplete='off'>
                        <div className='fieldFormItem'>
                            <label className='fieldFormLabel'>
                                {t.gettext('Field group name')}
                            </label>
                            <input
                                className='fieldFormInput'
                                defaultValue={fieldGroup ? fieldGroup.name : ''}
                                onInput={e => {
                                    setFieldGroupName(e.target.value);
                                }}
                                type='text'
                            />
                        </div>
                        <div className='fieldButtonsHolder'>
                            {!edit &&
                                <button
                                    className='fieldAddButton fieldEditButton'
                                    onClick={e => {
                                        e.preventDefault();
                                        handleCreateFieldGroupClick();
                                    }}
                                    disabled={disableButtons}
                                >
                                    {t.gettext('Save')}
                                    {disableButtons && <ButtonSpinner black/>}
                                </button>
                            }
                            {/*{edit &&*/}
                            {/*    <button*/}
                            {/*        className='fieldAddButton fieldEditButton'*/}
                            {/*        onClick={e => {*/}
                            {/*            e.preventDefault();*/}
                            {/*            handleEditFieldGroupClick();*/}
                            {/*        }}*/}
                            {/*        disabled={disableButtons}*/}
                            {/*    >*/}
                            {/*        {t.gettext('Save')}*/}
                            {/*        {disableButtons && <ButtonSpinner black/>}*/}
                            {/*    </button>*/}
                            {/*}*/}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default FieldGroupModal;
